<template>
  <div
    id="top-mention"
    class="h-100"
  >
    <div class="bg-white shade pb-2 pt-1 px-3 h-100">
      <!-- header component -->
      <h6 class="d-flex align-items-center">
        <div
          class="text-elipsis"
          v-tooltip.top="{ ref: 'titleTooltip' }"
        >
          <i class="bi bi-patch-check" /> {{ title }}
        </div>
        <div
          ref="titleTooltip"
          class="tooltip-content"
        >
          {{ title }}
        </div>
      </h6>
    </div>
    <div class="d-flex mt-1">
      <!-- <div class="col-md-12"> -->
      <div
        v-if="!data_mention"
        class="col-md-12"
      >
        <div
          class="alert alert-danger mt-3"
          id="errorApiEl"
          role="alert"
          align="center"
        >
          <strong>Mohon maaf, data tidak tersedia! </strong> <br>
          Silahkan lakukan pencarian dengan parameter lain
        </div>
      </div>
      <div
        v-else
        class="scroller "
        style="max-height: 45.8rem"
      >
        <div
          v-if="data_mention"
          class="scroller"
          style="max-height: 27.5rem"
        >
          <div
            class="d-flex align-items-center mb-2"
            v-for="(data, index) in data_mention"
            :key="index"
          >
            <div
              class="card-header bg-white w-100"
              style="cursor: text !important"
            >
              <div class="row post-content">
                <div class="col-md-11">
                  <h5 class="row">
                    <span
                      class="pull-left hoverable account-name col-10"
                      style="cursor: pointer !important"
                      @click="viewAccountDetail(data)"
                    >
                      <span v-if="data.source === 'twitter'">@</span>
                      <span
                        v-html="sosmed_list.includes(data.source) &&
                          data.source != 'youtube'
                          ? data.account || data.apps.name
                          : data.title
                        "
                      />
                      <span
                        v-if="cekPers(data.id_account)"
                        class="bg-orange label text-white p-t-1 p-b-1 fs-10"
                      >
                        Pers
                      </span>
                    </span>
                    <div
                      :id="'validation-status-' + index"
                      class="tooltip-content"
                    >
                      <p class="text-black">
                        Status Validasi
                      </p>
                      <p class="text-black">
                        Sentimen:
                        <b>
                          <span
                            v-if="data.updated_sentiment"
                            class="text-success"
                          >
                            Sudah divalidasi
                          </span>
                          <span
                            v-else
                            class="text-danger"
                          >
                            Belum divalidasi
                          </span>
                        </b>
                      </p>
                      <p class="text-black">
                        Emotion:
                        <b>
                          <span
                            v-if="data.updated_emotion"
                            class="text-success"
                          >
                            Sudah divalidasi
                          </span>
                          <span
                            v-else
                            class="text-danger"
                          >Belum divalidasi</span>
                        </b>
                      </p>
                    </div>
                    <div
                      :id="'tanggal-release-' + index"
                      class="tooltip-content"
                    >
                      <p class="text-black">
                        Detail Tanggal
                      </p>
                      <p class="text-black">
                        Publikasi:
                        <b>
                          <span class="text-success">
                            {{
                              data.source == "media_cetak" ||
                                data.source == "media_tv"
                                ? convertDate(data.date.$date)
                                : dateindo(data.date.$date)
                            }}</span>
                        </b>
                      </p>
                      <p class="text-black">
                        Tersimpan:
                        <b>
                          <span class="text-success">
                            {{
                              data.source == "media_cetak" ||
                                data.source == "media_tv"
                                ? newDateIndo(data.input_date.$date)
                                : newDateIndo(data.input_date.$date)
                            }}</span>
                        </b>
                      </p>
                    </div>
                    <span
                      class="pull-right fs-12 col-2"
                      style="margin-top: 2px !important"
                    >
                      <span
                        v-tooltip.top="{
                          html: 'tanggal-release-' + index,
                          class: 'tooltip-custom',
                        }"
                      >
                        <i class="bi bi-calendar-event" />
                        {{
                          data.source == "media_cetak" ||
                            data.source == "media_tv"
                            ? convertDate(data.date.$date)
                            : dateindo(data.date.$date)
                        }}
                      </span>
                      <span
                        v-if="'updated_emotion' in data || 'updated_sentiment' in data
                        "
                        class="pull-right"
                        style="margin-top: 0px !important; font-size: 22px"
                        v-tooltip.top="{
                          html: 'validation-status-' + index,
                          class: 'tooltip-custom',
                        }"
                      >
                        <i class="i bi-patch-check text-success" />
                      </span>
                      <span
                        v-else
                        class="pull-right"
                        style="margin-top: 0px !important; font-size: 22px"
                        v-tooltip.top="{
                          html: 'validation-status-' + index,
                          class: 'tooltip-custom',
                        }"
                      >
                        <i class="i bi-patch-check text-secondary" />
                      </span>
                    </span>
                    <div class="clearfix" />
                  </h5>
                  <div class="clearfix" />
                  <div class="d-flex align-items-center post-meta p-t-5">
                    <div
                      v-if="sosmed_list.includes(data.source)"
                      class="engagement-detail"
                    >
                      <span v-if="data.source != 'youtube'">
                        <span
                          v-for="(engagement, e_index) in data.engagement_detail"
                          :key="e_index"
                          :title="post_attribute[e_index]"
                          class="m-r-5 post-number"
                        >
                          <i :class="post_meta[e_index]" />
                          {{ engagement }}
                        </span>
                      </span>
                      <span v-else>
                        <span
                          v-for="(engagement, e_index) in data.engagement_detail"
                          :key="e_index"
                          :title="youtube_attribute[e_index]"
                          class="m-r-5 post-number"
                        >
                          <i :class="youtube_meta[e_index]" />
                          {{ engagement }}
                        </span>
                      </span>
                      <span
                        v-if="data.source == 'review'"
                        class="post-number m-r-5"
                        title="Skor"
                      >
                        <i class="bi bi-star-fill" />
                        {{ data.score ? data.score : 0 }}
                      </span>
                      <span
                        v-if="data.source == 'review'"
                        class="post-number m-r-5"
                        title="Skor"
                      >
                        <i
                          v-if="data.data_source == 'playstore'"
                          class="bi bi-android m-r-5"
                        />
                        <i
                          v-else
                          class="bi bi-apple m-r-5"
                        />
                        <span v-if="data.data_source == 'playstore'">Play Store</span>
                        <span v-else>App Store</span>
                      </span>
                      <span
                        v-if="data.source != 'review'"
                        class="post-number"
                        title="Pengikut"
                      >
                        <i class="bi bi-people" />
                        {{ data.followers ? data.followers : 0 }}
                      </span>

                      <span
                        v-if="data.source != 'review'"
                        class="separator"
                      >|</span>
                      <span
                        v-if="data.source != 'review'"
                        class="m-l-5 post-number"
                        title="Jangkauan"
                      >
                        <i class="bi bi-megaphone" />
                        {{ Math.round(data.esmr) !== 0 ? Math.round(data.esmr) : 0 }}
                      </span>

                      <span
                        v-if="data.source != 'review'"
                        class="m-r-10 m-l-5 post-number"
                        title="Keterlibatan"
                      >
                        <i class="bi bi-share-fill" />
                        {{
                          data.engagement_count
                            ? data.engagement_count
                            : 0
                        }}
                      </span>
                    </div>
                    <span
                      v-if="!sosmed_list.includes(data.source) &&
                        data.source != 'media_tv' &&
                        data.source != 'media_cetak'
                      "
                      class="m-r-10 m-l-5 post-number hoverable"
                      @click="viewAccountDetail(data)"
                      title="Sumber"
                    >
                      <i class="bi bi-globe-americas" />
                      {{ data.account ? data.account : "Tidak Tercantum" }}
                    </span>
                    <span
                      v-if="data.source == 'media_cetak'"
                      class="m-r-10 m-l-5 post-number hoverable"
                      title="Sumber Media Cetak"
                      @click="viewAccountDetail(data)"
                    >
                      <i class="bi bi-newspaper" />
                      {{ data.account ? data.account : "Tidak Tercantum" }}
                    </span>
                    <span
                      v-if="data.source == 'media_tv'"
                      class="m-r-10 m-l-5 post-number hoverable"
                      title="Channel TV - Nama Program"
                      @click="viewAccountDetail(data)"
                    >
                      <i class="bi bi-tv" />
                      {{ data.account ? data.account : "Tidak Tercantum" }} -
                      {{ data.program ? data.program : "Tidak Tercantum" }}
                    </span>
                    <span
                      v-if="data.source == 'media_cetak' || data.source == 'media_tv'
                      "
                      class="m-r-10 m-l-5 post-number"
                      title="Jurnalis"
                    >
                      <i class="bi bi-person" />
                      {{ data.journalist ? data.journalist : "Tidak Tercantum" }}
                    </span>
                    <span
                      v-if="data.source == 'news' && data.author"
                      class="m-r-10 m-l-5 post-number"
                      title="Jurnalis"
                    >
                      <i class="bi bi-person" />
                      {{ data.author ? data.author : "Tidak Tercantum" }}
                    </span>
                    <span
                      v-if="data.source == 'media_cetak' || data.source == 'media_tv'
                      "
                      class="m-r-10 m-l-5 post-number"
                      title="Ad Value"
                    >
                      <b>AD</b> IDR
                      {{
                        data.rate_fc > 0 && data.rate_fc > 0
                          ? data.rate_fc
                          : data.rate_fc > 0 && data.rate_bw == 0
                            ? data.rate_fc
                            : data.rate_fc == 0 && data.rate_bw > 0
                              ? data.rate_bw
                              : 0
                      }}
                    </span>
                    <span
                      v-if="data.source == 'news'"
                      class="m-r-10 m-l-5 post-number"
                      title="Nilai Iklan"
                    >
                      <b>AD</b> IDR {{ data.ad_value }}
                    </span>

                    <span
                      v-if="data.source == 'media_cetak' ||
                        data.source == 'media_tv' ||
                        data.source == 'news'
                      "
                      class="m-r-10 m-l-5 post-number"
                      title="Nilai Hubungan Masyarakat"
                    >
                      <b>PR</b> IDR {{ data.pr_value }}
                    </span>
                    <span
                      v-if="data.source == 'media_cetak' ||
                        data.source == 'media_tv' ||
                        data.source == 'news'
                      "
                      class="m-r-10 m-l-5 post-number"
                      title="Nilai Amec"
                    >
                      <b>a</b> {{ data.amec ? data.amec : 0 }}
                    </span>
                    <span
                      v-if="data.source == 'media_cetak'"
                      class="m-r-10 m-l-5 post-number"
                      title="Nomor Halaman"
                    >
                      <b>HAL</b> {{ data.page }}
                    </span>
                    <div
                      class="m-r-5"
                      v-else
                    >
                      <span
                        class="label"
                        :class="data.sentiment == 1
                          ? 'label-success'
                          : data.sentiment == 0
                            ? 'label-info'
                            : 'label-danger'
                        "
                      >{{
                        data.sentiment == 1
                          ? "Positif"
                          : data.sentiment == 0
                            ? "Netral"
                            : "Negatif"
                      }}</span>
                    </div>
                    <span
                      v-if="data.highlight"
                      class="post-number m-r-5"
                      title="Serupa dengan posting di highlight"
                    >
                      <i
                        class="bi bi-star-fill"
                        style="color: #ffc107"
                      />
                    </span>
                    <div
                      v-if="'emotion' in data &&
                        isAdmin &&
                        data.source != 'news' &&
                        data.source != 'media_cetak' &&
                        data.source != 'media_tv'
                      "
                      :id="'emotion-' + index"
                      class="tooltip-content"
                      style="width: 100%"
                    >
                      <div style="width: 100%">
                        <div
                          class="emot-wrapper"
                          align="center"
                          @click.prevent="changeEmotion(index, 0)"
                        >
                          <a
                            href="#"
                            class="m-r-5 text-black emotion-icon"
                            title="Netral"
                          >
                            <i class="bi bi-emoji-neutral" />
                          </a>
                          <p class="text-secondary">
                            Netral
                          </p>
                        </div>
                        <div
                          class="emot-wrapper"
                          align="center"
                          @click.prevent="changeEmotion(index, 1)"
                        >
                          <a
                            href="#"
                            class="m-r-5 text-success emotion-icon"
                            title="Senang"
                          >
                            <i class="bi bi-emoji-smile" />
                          </a>
                          <p class="m-0 p-0 text-secondary">
                            Senang
                          </p>
                        </div>
                        <div
                          class="emot-wrapper"
                          align="center"
                          @click.prevent="changeEmotion(index, 2)"
                        >
                          <a
                            href="#"
                            class="m-r-5 text-warning emotion-icon"
                            title="Takut"
                          >
                            <i class="bi bi-emoji-dizzy" />
                          </a>
                          <p class="m-0 p-0 text-secondary">
                            Takut
                          </p>
                        </div>
                        <div
                          class="emot-wrapper"
                          align="center"
                          @click.prevent="changeEmotion(index, 3)"
                        >
                          <a
                            href="#"
                            class="m-r-5 text-blue emotion-icon"
                            title="Sedih"
                          >
                            <i class="bi bi-emoji-frown" />
                          </a>
                          <p class="m-0 p-0 text-secondary">
                            Sedih
                          </p>
                        </div>
                        <div
                          class="emot-wrapper"
                          align="center"
                          @click.prevent="changeEmotion(index, 4)"
                        >
                          <a
                            href="#"
                            class="m-r-5 text-danger emotion-icon"
                            title="Marah"
                          >
                            <i class="bi bi-emoji-angry" />
                          </a>
                          <p class="m-0 p-0 text-secondary">
                            Marah
                          </p>
                        </div>
                      </div>
                    </div>

                    <span
                      v-if="'emotion' in data &&
                        isAdmin &&
                        data.source != 'news' &&
                        data.source != 'media_cetak' &&
                        data.source != 'media_tv'
                      "
                      :id="'actual-emotion-' + index"
                      class="post-number"
                      v-tooltip.top.click="{
                        html: 'emotion-' + index,
                        class: 'tooltip-custom',
                      }"
                    >
                      <i
                        v-if="data.emotion == 0"
                        class="bi bi-emoji-neutral"
                        style="font-size: 16px"
                        title="Netral"
                      />
                      <i
                        v-if="data.emotion == 1"
                        class="bi bi-emoji-smile text-success"
                        style="font-size: 16px"
                        title="Senang"
                      />
                      <i
                        v-if="data.emotion == 2"
                        class="bi bi-emoji-dizzy text-warning"
                        style="font-size: 16px"
                        title="Takut"
                      />
                      <i
                        v-if="data.emotion == 3"
                        class="bi bi-emoji-frown text-blue"
                        style="font-size: 16px"
                        title="Sedih"
                      />
                      <i
                        v-if="data.emotion == 4"
                        class="bi bi-emoji-angry text-danger"
                        style="font-size: 16px"
                        title="Marah"
                      />
                    </span>
                    <span v-else>
                      <span
                        v-if="data.source != 'news' &&
                          data.source != 'media_cetak' &&
                          data.source != 'media_tv'
                        "
                        :id="'actual-emotion-' + index"
                        class="post-number"
                      >
                        <i
                          v-if="data.emotion == 0"
                          class="bi bi-emoji-neutral"
                          style="font-size: 16px"
                          title="Netral"
                        />
                        <i
                          v-if="data.emotion == 1"
                          class="bi bi-emoji-smile text-success"
                          style="font-size: 16px"
                          title="Senang"
                        />
                        <i
                          v-if="data.emotion == 2"
                          class="bi bi-emoji-dizzy text-warning"
                          style="font-size: 16px"
                          title="Takut"
                        />
                        <i
                          v-if="data.emotion == 3"
                          class="bi bi-emoji-frown text-blue"
                          style="font-size: 16px"
                          title="Sedih"
                        />
                        <i
                          v-if="data.emotion == 4"
                          class="bi bi-emoji-angry text-danger"
                          style="font-size: 16px"
                          title="Marah"
                        />
                      </span>
                    </span>
                  </div>
                  <div class="post-text-content">
                    <div
                      class="text-content"
                      :id="'text-content-' + index"
                      v-html="writeContent(data.content)"
                    />
                    <div
                      v-if="data.in_medias != null"
                      class="in-medias m-t-10 hide"
                      id="media"
                    >
                      <div
                        v-for="(in_media, in_media_index) in data.in_medias"
                        :key="in_media_index"
                        class="post-img-wrapper"
                        align="center"
                      >
                        <img
                          v-if="in_media.type == 'photo'"
                          :height="in_media.sizes.small.h"
                          :width="in_media.sizes.small.w"
                          :src="in_media.media_url_https"
                          alt="Image Post"
                          style="width: auto"
                        >
                      </div>
                    </div>
                    <div
                      v-if="data.photo"
                      class="in-medias m-t-10 hide"
                      id="media"
                    >
                      <img
                        :src="data.photo"
                        alt=""
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="row post-action m-t-10">
                <div class="col-md-12 col-sm-12 col-lg-12">
                  <div class="row">
                    <div
                      v-if="data.source == 'twitter'"
                      class="col-md-3 col-11"
                    >
                      <div v-if="data.topics">
                        Topik:
                        <div
                          v-for="(t, tIndex) in data.topics"
                          :key="tIndex"
                          class="btn btn-xs btn-rounded btn-default fs-10 m-r-5"
                        >
                          <span>{{ showTopicName(t.$oid) }}</span>
                        </div>
                      </div>
                    </div>
                    <div
                      v-else-if="data.source == 'facebook' ||
                        data.source == 'instagram' ||
                        data.source == 'youtube' ||
                        data.source == 'linkedin' ||
                        data.source == 'tiktok' ||
                        data.source == 'forum' ||
                        data.source == 'blog'
                      "
                      class="col-md-5 col-11"
                    >
                      <div v-if="data.topics">
                        Topik:
                        <div
                          v-for="(t, tIndex) in data.topics"
                          :key="tIndex"
                          class="btn btn-xs btn-rounded btn-default fs-10 m-r-5"
                        >
                          <span>{{ showTopicName(t.$oid) }}</span>
                        </div>
                      </div>
                    </div>
                    <div
                      v-else
                      class="col-md-5 col-11"
                    >
                      <div v-if="data.topics">
                        Topik:
                        <div
                          v-for="(t, tIndex) in data.topics"
                          :key="tIndex"
                          class="btn btn-xs btn-rounded btn-default fs-10 m-r-5"
                        >
                          <span
                            v-if="!isViewer"
                            class="bi bi-x text-danger fa-lg"
                            @click="deleteTopik(t.$oid, index)"
                          >
                                                        &nbsp;</span>
                          <span
                            v-if="!isViewer"
                            class="mr-1"
                          >|</span>
                          <span>{{ showTopicName(t.$oid) }}</span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-md-2 col-12"
                      v-if="data.source == 'twitter'"
                    >
                      <div
                        class="in-reply"
                        v-if="data.in_reply_to"
                      >
                        <div
                          class="in-reply-to"
                          v-if="data.in_reply_to.name && data.in_reply_to.id"
                        >
                          in reply to:
                          <a
                            :href="'https://twitter.com/' +
                              data.in_reply_to.name +
                              '/status/' +
                              data.in_reply_to.id
                            "
                            style="color: blue; opacity: 0.8 !important"
                            target="__blank"
                          >@{{ data.in_reply_to.name
                          }}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix" />
    </div>
  </div>
  <!-- </div> -->
</template>
<script>
import $ from "jquery";
// import loader from "../loader.vue";
import gp from "@/plugins/generalPlugins.js";
import notif from "@/assets/js/notif.js";
import * as linkify from "linkifyjs";
import linkifyHtml from "linkifyjs/html";
import hashtag from "linkifyjs/plugins/hashtag";
hashtag(linkify);
$.pgNotification = notif;
import axios from "axios";
import { getTopicKeyword } from "@/models/topic.js";

var sosmed_icon = new Array();
sosmed_icon["facebook"] = "bi bi-facebook";
sosmed_icon["twitter"] = "bi bi-twitter-x";
sosmed_icon["youtube"] = "bi bi-youtube";
sosmed_icon["instagram"] = "bi bi-instagram";
sosmed_icon["news"] = "bi bi-globe-americas";
sosmed_icon["blog"] = "bi bi-rss";
sosmed_icon["forum"] = "bi bi-chat-dots-fill";
sosmed_icon["media_cetak"] = "bi bi-newspaper";
sosmed_icon["media_tv"] = "bi bi-tv";
sosmed_icon["linkedin"] = "bi bi-linkedin";
sosmed_icon["tiktok"] = "bi bi-tiktok";
sosmed_icon["review"] = "bi bi-phone";

var post_meta = [];
post_meta["comment"] = "bi bi-chat-fill";
post_meta["view"] = "bi bi-eye";
post_meta["rt"] = "bi bi-repeat";
post_meta["share"] = "bi bi-share";
post_meta["like"] = "bi bi-heart-fill";
post_meta["fav"] = "bi bi-heart-fill";
post_meta["play"] = "bi bi-play";

var youtube_meta = [];
youtube_meta["comment"] = "bi bi-chat-fill";
youtube_meta["view"] = "bi bi-eye";
youtube_meta["like"] = "bi bi-hand-thumbs-up";
youtube_meta["dislike"] = "bi bi-hand-thumbs-down";
youtube_meta["favorite"] = "bi bi-heart-fill";

var post_attribute = [];
post_attribute["fav"] = "Disukai";
post_attribute["like"] = "Disukai";
post_attribute["rt"] = "Retweet";
post_attribute["share"] = "Bagikan";
post_attribute["comment"] = "Komentar";
post_attribute["view"] = "Lihat";
post_attribute["play"] = "Putar";

var youtube_attribute = [];
youtube_attribute["favorite"] = "Favorit";
youtube_attribute["like"] = "Disukai";
youtube_attribute["dislike"] = "Tidak Disukai";
youtube_attribute["comment"] = "Komentar";
youtube_attribute["view"] = "Lihat";

export default {
    name: "TopMention",
    // components: {
    //     "loader-component": loader,
    // },
    props: {
        title: {
            type: String,
            default: function () {
                return "";
            },
        },
        tipe_mention: {
            tipe_mention: String,
            default: function () {
                return "";
            },
        },
    },
    data() {
        return {
            is_loading: true,
            id_project: this.$store.getters.user.id_project,
            items: 10,
            topics: null,
            data_mention: null,
            type_most: this.tipe_mention,
            post_attribute: post_attribute,
            post_meta: post_meta,
            item_checked: [],
            sosmed_list: [
                "facebook",
                "instagram",
                "twitter",
                "tiktok",
                "youtube",
                "linkedin",
                "forum",
                "blog",
                "review",
            ],
            youtube_meta: youtube_meta,
            youtube_attribute: youtube_attribute,
            pers: null,
            highlight_list: [],
            topic_keyword: [],

        };
    },
    mounted() {
        this.getTopMention();
    },
    methods: {
        getTopMention: function () {
            let params = {
                items: this.items,
                sort: this.type_most,
            };
            let query = Object.keys(params)
                .map((key) => key + "=" + params[key])
                .join("&");
            const api = `${process.env.VUE_APP_API_URL}most-mention/top/${this.id_project}?${query}`;
            this.$http.get(api).then((response) => {
                if (response.status == 200) {
                    this.data_mention = response.data;
                } else {
                    this.data_mention = {};
                }
            });
        },
        cekPers: function (_id) {
            if (this.pers != null) {
                return this.pers.includes(_id);
            } else {
                return false;
            }
        },
        newDateIndo: function (tanggal) {
            return gp.dateIndonesia(tanggal);
        },
        dateindo: function (tanggal) {
            return gp.dateTimeID(tanggal);
        },
        setSource(source) {
            if (source == "news") {
                return "Media Online";
            } else if (source == "media_cetak") {
                return "Media Cetak";
            } else if (source == "media_tv") {
                return "Media TV";
            } else if (source == "review") {
                return "Review Aplikasi";
            }
        },
        setIcon(source) {
            if (source == "news") {
                return "bi bi-globe-americas";
            } else if (source == "media_cetak") {
                return "bi bi-newspaper";
            } else if (source == "media_tv") {
                return "bi bi-tv";
            } else if (source == "twitter") {
                return "bi bi-twitter-x";
            } else if (source == "facebook") {
                return "bi bi-facebook";
            } else if (source == "instagram") {
                return "bi bi-instagram";
            } else if (source == "youtube") {
                return "bi bi-youtube";
            } else if (source == "tiktok") {
                return "bi bi-tiktok";
            } else if (source == "linkedin") {
                return "bi bi-linkedin";
            } else if (source == "forum") {
                return "bi bi-chat-dots-fill";
            } else if (source == "blog") {
                return "bi bi-rss";
            } else if (source == "review") {
                return "bi bi-phone";
            }
            return "bi bi-circle";
        },
        imageUrlAlt: function () {
            event.target.src = "/assets/img/profiles/default.png";
        },
        kmbFormatter: function (number) {
            return gp.kmbFormatter(number);
        },
        showTopicName: function (_id) {
            if (this.topics != null) {
                for (let grup in this.topics.formed) {
                    for (let topic in this.topics.formed[grup].topics) {
                        if (_id == topic) {
                            return this.topics.formed[grup].topics[topic];
                        }
                    }
                }
                if (_id in this.topics.socmed) {
                    return this.topics.socmed[_id];
                } else {
                    return false;
                }
            } else {
                return "-";
            }
        },
        getTopic: function () {
            var self = this;
            let api = process.env.VUE_APP_API_URL + "list-topics/" + this.id_project;
            this.$http
                .get(api)
                .then(function (response) {
                    if (response.status == 204) {
                        self.topics = {};
                    } else {
                        self.topics = response.data;
                    }
                })
                .catch(function () {
                    self.topics = {};
                })
                .finally(() => {
                    this.getTopMention();
                    // this.getFiltersData();
                    // this.getFiltersSentiment();
                });
        },
        getPers: function () {
            var self = this;
            let api = process.env.VUE_APP_API_URL + "pers";
            this.$http
                .get(api)
                .then(function (response) {
                    if (response.status == 204) {
                        self.pers = [];
                    } else {
                        self.pers = response.data;
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    self.pers = [];
                });
        },
        getChannel: function () {
            let api =
                process.env.VUE_APP_API_URL + "project-detail/" + this.id_project;
            axios({ url: api, data: {}, method: "GET" }).then((response) => {
                this.activeChannel = response.data.project_detail.crawler;
            });
        },
        getHighlight: function () {
            let api =
                process.env.VUE_APP_API_URL + "highlight-ids/" + this.id_project;
            this.$http
                .get(api)
                .then((response) => {
                    if (response.status == 200) {
                        this.highlight_list = response.data;
                    }
                })
                .catch(() => {
                    this.highlight_list = [];
                });
        },
        createAutoLink: function (text) {
            return linkifyHtml(text, {
                defaultProtocol: "https",
                ignoreTags: ["mark"],
                validate: {
                    url: function (value) {
                        return /^(http|ftp)s?:\/\//.test(value);
                    },
                },
            });
        },
        writeContent: function (text) {
            var batasKata = this.stringLimit;
            var newText = text.substring(0, batasKata);
            var last_index = newText.lastIndexOf(" ");
            var cekMark = text.substring(last_index);
            if (newText.length == batasKata) {
                if (cekMark.includes("mark")) {
                    newText = newText.substring(0, last_index);
                }
                newText += "...";
            }

            if ("q" in this.$route.query) {
                newText = this.markString(newText);
            }
            newText = this.createAutoLink(newText);
            newText = newText.replace(/\n/g, "<br />");

            return newText;
        },
    },
    computed: {
        isAdmin: function () {
            let user_role = this.$store.getters.user.role;
            if (user_role == 2 || user_role == 3) {
                return true;
            }
            return false;
        },
        isViewer: function () {
            let user_role = this.$store.getters.user.role;
            if (user_role == 4) {
                return true;
            }
            return false;
        },
    },
    filters: {
        showPicture: function (data) {
            let pro_pic;
            switch (data.source) {
                case "twitter":
                    pro_pic = data.profile_image;
                    break;
                case "instagram":
                    pro_pic = data.profile_image;
                    break;
                case "facebook":
                    pro_pic = data.profile_photo;
                    break;
                case "youtube":
                    pro_pic = data.thumbnails;
                    break;
                case "linkedin":
                    pro_pic = data.profile_picture;
                    break;
                case "tiktok":
                    pro_pic = data.profile_picture;
                    break;
                default:
                    pro_pic = "/assets/img/profiles/default.png";
                    break;
            }

            if (pro_pic == null) {
                pro_pic = "/assets/img/profiles/default.png";
            }
            return pro_pic;
        },
    },
    created: async function () {
        this.topic_keyword = await getTopicKeyword(
            this.$store.getters.user.id_project
        );
        this.getPers();
        this.getHighlight();
        this.getTopic();
        this.getChannel();
    },
};
</script>
